// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"Loading_loading-wrapper__pJIJj","lds-ring":"Loading_lds-ring__luCSg","white":"Loading_white__Xw6Km"};